import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import download from "../images/download-doc.svg";
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from "@mui/material/Divider";
import spinner from "../../assign-prescriptions/images/spinner.gif";
import Typography from "@mui/material/Typography";
import { FormControl, IconButton, InputLabel, Select, MenuItem } from "@mui/material";
import { TableContainer } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from "moment-timezone";
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { frFR } from "@mui/material/locale";
import { enUS } from "@mui/material/locale";

const localeTheme = createTheme(
  {},
  localStorage.getItem("i18nextLng") === "en" ? enUS : frFR
);
function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};
function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function stableSort(array, cmp) {
  if (array && array.length <= 0) {
    return [];
  }
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = cmp(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

function getSorting(order, orderBy) {
  return order === "desc"
    ? (a, b) => desc(a, b, orderBy)
    : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const { order, orderBy, sortId, t } = this.props;
    const rows = [
      {
        id: "given_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.FirstName"),
        padding: "10px",
        field: "given_name",
      },
      {
        id: "family_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.LastName"),
        padding: "10px",
        field: "family_name",
      },
      {
        id: "external_id",
        numeric: false,
        disablePadding: false,
        label: t("Report.HLOrderStaging.ExternalId"),
        padding: "10px",
        field: "external_id",
      },
      {
        id: "internal_id",
        numeric: false,
        disablePadding: false,
        label: t("Report.HLOrderStaging.InternalId"),
        padding: "10px",
        field: "internal_id",
      },
      {
        id: "dob",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DOB"),
        padding: "10px",
        field: "dob",
      },
      {
        id: "email",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.Email"),
        padding: "10px",
        field: "email",
      },
      {
        id: "phone",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.Phone"),
        padding: "10px",
        field: "sms_phone",
      },
      {
        id: "prescription_number",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.PrescriptionNumber"),
        padding: "10px",
        field: "prescription_number",
      },
      {
        id: "text_name",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DrugName"),
        padding: "10px",
        field: "drug_name",
      },
      {
        id: "dispense_amount",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.AmountDue"),
        padding: "10px",
        field: "dispense_amount",
      },
      {
        id: "quantity",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.DispensedQty"),
        padding: "10px",
        field: "quantity",
      },
      {
        id: "end_date",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.ExpiryDate"),
        padding: "10px",
        field: "end_date",
      },
      {
        id: "created_on",
        numeric: false,
        disablePadding: false,
        label: t("Report.OrderStaging.OrderTimestamp"),
        padding: "10px",
        field: "created_on",
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: "rgba(0, 0, 0, 0.54)" }}
              >
                {[
                  "external_id",
                  "internal_id",
                  "email",
                  "phone",
                  "quantity",
                  "dispense_amount",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t("Global.Label.Filter.Sort")}
                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = (theme) => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  dob: {
    paddingTop: "25px",
  },
  headerdiv: {
    paddingLeft: "15%",
    paddingTop: "10",
  },
  padding10px: {
    padding: "10px",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: "absolute",
    width: "89%",
    height: "70%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(255,255,255,0.5)",
    zIndex: "7869",
  },
  spinner: {
    position: "absolute",
    background: "rgba(255,255,255,.4)",
    width: "100%",
    height: "100%",
    zIndex: "9999",
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: "calc(50% - 32.5px)",
    left: "calc(50% - 65px)",
    position: "absolute",
    width: "130px",
    userSelect: "none",
  },
  hidden: {
    display: "none",
  },
  rowheight: {
    height: "35px",
  },
});

let OrderViewFilterObj = {
  searchtext: "",
  fromdate: "",
  todate: "",
  pageNo: 0,
  pageSize: 10,
  sortOrder: "desc",
  sortColumn: "created_on",
  tableName: "",
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class HLOrdersView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: "",
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext: "",
      store_id: [],
      box_id: [],
      fromdate: null,
      todate: null,
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      selectedObject: null,
      isDataEmpty: true,
      selectedTab: 0,
      tempThresholds: [],
      totalRecords: 0,
      locale: localStorage.getItem("i18nextLng") === "en" ? enLocale : frLocale,
      queryId: "",
      groups: [],
    };
    this.debouceTimeout = null;
  }

  componentDidMount() {
    OrderViewFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    this.fetchSuggestions();
    this.BindGrid();
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem("i18nextLng");
    let zone;
    zone = sessionStorage.getItem("timeZone");
    const date = moment(new Date(requestDate));
    if (["null", null, "undefined", undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === "en"
      ? date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("MM/DD/YYYY hh:mm:ss A")
      : date
        .tz(zone.substring(zone.lastIndexOf(" ") + 1))
        .format("DD/MM/YYYY hh:mm:ss A");
  };

  gettingOnSortTableName = (field) => {
    let tablename = "";
    if (
      [
        "order_status",
        "external_id",
        "internal_id",
        "family_name",
        "given_name",
        "middle_name",
        "dob",
        "alternate_dob",
        "end_date",
        "text_name",
        "given_doses_form",
        "dispense_amount",
        "dispense_units",
        "prescription_number",
        "phone",
        "created_on",
      ].includes(field)
    ) {
      tablename = "hl_order_staging";
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    OrderViewFilterObj.sortOrder = order;
    OrderViewFilterObj.sortColumn = field;
    OrderViewFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    const { data } = this.state;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    const { data } = this.state;
    OrderViewFilterObj.pageNo = page;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    const { data } = this.state;
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.pageSize = event.target.value;
    if (data && data.length > 0) {
      this.BindGrid();
    }
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000);
  };

  onFromDateSelect = (date) => {
    date = date ? moment(date).format() : "";
    this.setState({ fromdate: date });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.fromdate = date ? moment(date).format("YYYY-MM-DD") : "";
    this.BindGrid();
  };

  onToDateSelect = (date) => {
    date = date ? moment(date).format() : "";
    this.setState({ todate: date });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.todate = date ? moment(date).format("YYYY-MM-DD") : "";
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    this.setState({
      fromdate: null,
    });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.fromdate = date ? moment(date).format("YYYY-MM-DD") : "";
    this.BindGrid();
  };

  handleBlurtodate = (value, date) => {
    this.setState({
      todate: null,
    });
    OrderViewFilterObj.pageNo = 0;
    OrderViewFilterObj.sortOrder = "desc";
    OrderViewFilterObj.sortColumn = "created_on";
    OrderViewFilterObj.tableName = "";
    OrderViewFilterObj.todate = date ? moment(date).format("YYYY-MM-DD") : "";
    this.BindGrid();
  };

  BindGrid() {
    this.setState({ loader: true, data: null });
    fetch(process.env.REACT_APP_BASEURL + "hl/orders/list", {
      method: "post",
      withCredentials: true,
      headers: {
        Authorization:
          "Bearer " +
          JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
            .jwtToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(OrderViewFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((uData) => {
        if (
          uData &&
          uData.data &&
          uData.data.results &&
          uData.data.results.length > 0
        ) {
          this.setState({
            data: uData && uData.data && uData.data.results,
            totalRecords: uData && uData.data && uData.data.total,
          });
          setTimeout(() => {
            this.setState({
              loader: uData && uData.total && false,
              isDataEmpty: false,
            });
          }, 5000);
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  }

  getPhoneNumber = (phoneString) => {
    if (![undefined, undefined, null, null, ""].includes(phoneString)) {
      return this.cleanPhoneNumber(phoneString);
    } else {
      return null;
    }
  };

  cleanPhoneNumber(phoneNumber) {
    return phoneNumber ? phoneNumber.replace(/[()\s-]/g, '') : phoneNumber;
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    OrderViewFilterObj.group_id = event.target.value;
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const { classes, t } = this.props;
    const { data, totalRecords, locale, queryId, groups } = this.state;
    return (
      <Paper id="react-no-print" className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div>
        ) : null}
        <div id="react-no-print">
          <Table className={classes.table} aria-labelledby="tableTitle">
            <TableBody>
              <TableRow>
                <TableCell
                  style={{
                    width: "20%",
                    borderBottom: "none",
                    paddingTop: "13px",
                  }}
                >
                  <FormControl sx={{ width: "100%" }}>
                    <LocalizationProvider
                      dateAdapter={DateAdapter}
                      locale={locale}
                    >
                      <DesktopDatePicker
                        disableFuture
                        keyboard
                        value={this.state.fromdate}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("Report.OrderStaging.FromDate")}
                            variant="standard"
                            allowKeyboardControl={true}
                            onBlur={this.handleBlurfrom}
                          />
                        )}
                        onChange={this.onFromDateSelect}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </TableCell>
                <TableCell
                  style={{
                    width: "20%",
                    borderBottom: "none",
                    paddingTop: "13px",
                  }}
                >
                  <FormControl sx={{ width: "100%" }}>
                    <LocalizationProvider
                      dateAdapter={DateAdapter}
                      locale={locale}
                    >
                      <DesktopDatePicker
                        disableFuture
                        keyboard
                        value={this.state.todate}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={t("Report.OrderStaging.ToDate")}
                            variant="standard"
                            allowKeyboardControl={true}
                            onBlur={this.handleBlurtodate}
                          />
                        )}
                        onChange={this.onToDateSelect}
                      />
                    </LocalizationProvider>
                  </FormControl>
                </TableCell>
                <TableCell style={{ width: "20%", borderBottom: "none" }}>
                  <TextField
                    id="idsearchtxt"
                    defaultValue=""
                    value={this.state.searchtxt}
                    label={t("Report.OrderStaging.Search")}
                    onChange={this.onSearchChange}
                    className={classes.formControl}
                    fullWidth
                    inputProps={{
                      autocomplete: "new-password",
                      form: {
                        autocomplete: "off",
                      },
                    }}
                    variant="standard"
                  />
                </TableCell>
                <TableCell style={{ width: "20%", borderBottom: "none" }}>
                  <FormControl
                    variant='standard'
                    sx={{ m: '16px 0', minWidth: 347 }}
                  >
                    <InputLabel id='preferred-group-label'>
                      {t('Group.User.GroupControlTitle')}
                    </InputLabel>
                    <Select
                      labelId='preferred-group-label'
                      id='preferred-group-select-standard'
                      value={queryId}
                      onChange={this.handleInputChange}
                      variant='standard'
                      label={t('Group.User.GroupControlTitle')}
                    >
                      {groups.length > 0 &&
                        groups.map((type, index) => (
                          <MenuItem
                            key={index}
                            value={type.id}
                            className={classes.locationType}
                          >
                            {type.name}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell
                  style={{
                    width: "20%",
                    borderBottom: "none",
                    textAlign: "right",
                  }}
                >
                  <Tooltip
                    key="single-edit"
                    title={t("Report.OrderStaging.ExportCSVTooltip")}
                  >
                    <IconButton
                      style={{ marginRight: "0" }}
                      aria-label="ExportCSV"
                    >
                      <img
                        alt="download"
                        onClick={() => {
                          this.exportCSV();
                        }}
                        src={download}
                        style={{
                          height: "32px",
                          width: "32px",
                          cursor: "pointer",
                        }}
                      />
                    </IconButton>
                  </Tooltip>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <Divider style={{ marginTop: "10px", height: "5px" }} />
        <div className={classes.tableWrapper}>
          <TableContainer>
            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                order={OrderViewFilterObj.sortOrder}
                orderBy={OrderViewFilterObj.sortColumn}
                sortId={this.state.sortId}
                onRequestSort={this.handleRequestSort}
              />
              <TableBody>
                {!data ? (
                  <TableRow>
                    <TableCell
                      colSpan={21}
                      style={{ textAlign: "center", padding: "10px 0px" }}
                    >
                      {this.state.isDataEmpty &&
                        t("Report.OrderStaging.NoDataFound")}
                    </TableCell>
                  </TableRow>
                ) : (
                  data.length &&
                  data.length > 0 &&
                  stableSort(
                    data,
                    getSorting(
                      OrderViewFilterObj.sortOrder,
                      OrderViewFilterObj.sortColumn
                    )
                  ).map((n) => {
                    return (
                      <TableRow>
                        <TableCell className={classes.padding10px}>
                          {n.given_name}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.family_name}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.external_id}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.internal_id}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {[undefined, "undefined", null, "null", ""].includes(
                            n.dob
                          )
                            ? n.alternate_dob
                            : n.dob}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.email}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {this.getPhoneNumber(n.phone)}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.prescription_number}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.text_name}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.dispense_amount
                            ? "$" + parseFloat(n.dispense_amount).toFixed(2)
                            : "$0.00"}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.quantity}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.end_date}
                        </TableCell>
                        <TableCell className={classes.padding10px}>
                          {n.created_on
                            ? this.convertToTimeZone(n && n.created_on)
                            : ""}
                        </TableCell>
                      </TableRow>
                    );
                  })
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <ThemeProvider theme={localeTheme}>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={totalRecords || 0}
            rowsPerPage={OrderViewFilterObj.pageSize}
            page={OrderViewFilterObj.pageNo}
            backIconButtonProps={{
              "aria-label": "Previous Page",
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page",
            }}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </Paper>
    );
  }
}

HLOrdersView.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(HLOrdersView)
);



// WEBPACK FOOTER //
// ./src/components/reports/hl_orders_view/index.js